module.exports = __webpack_public_path__ + "static/media/BreathAwareness15.e9d72635.m4a";